<template>
  <div>
    <!-- <p v-if="postgres.statefips === '37'" class="text-caption">
      North Carolina population estimates are based on 2015-19 ACS block group population allocated to 2019 districts.
      </p> -->
  <v-simple-table dense class="table-wrap-type mt-1 mb-1">
    <template 
    v-slot:default>
      <thead>
        <tr>
          <th colspan="2">
            2020 Census data
            <!-- ACS 2015-19 Estimates -->
            <!-- Estimated district pop. compared to 2020 average  -->
          </th>
          <!-- <th>
          </th> -->
        </tr>
      </thead>
      <tbody v-if="!(postgres.popdifffromavg === null || typeof postgres.popdifffromavg === 'undefined')">
        <tr>
          <!-- <td>New {{ postgres.stusps }} avg. district pop. (2020)</td> -->
          <td>Average district pop. in {{ postgres.stusps }}<!--  (2015-19 ACS) --></td>
          <td v-if="postgres.stusps === 'HI'" class="text-right">To be determined</td>
          <td v-else class="text-right">{{ Math.round(postgres.stateavg).toLocaleString() }}</td>
        </tr>

        <tr class="font-italic">
          <!-- SR COMMENTED OUT MULTIMEMBER 'PER REP' VALUES b/c of WASHINGTON STATE FEEDBACK -->
          <!-- <td v-if="postgres.repcount ===1">{{ postgres.districtname }} pop.</td>
          <td v-else>{{ postgres.districtname }} pop. per representative</td> -->
          <td>{{ postgres.districtname }} population</td>
          <!-- <td width="35%" v-if="postgres.repcount ===1" class="text-right">
            <a v-bind:href="'https://data.census.gov/cedsci/table?g=610U600US' + postgres.geoid + '&y=2019&d=ACS%205-Year%20Estimates%20Detailed%20Tables&tid=ACSDT5Y2019.B01003'" target="_blank">{{ Math.trunc(postgres.pop2020 / postgres.repcount).toLocaleString() }}</a>
            </td>
          <td width="35%" v-else class="text-right">{{ Math.trunc(postgres.pop2020 / postgres.repcount).toLocaleString() }}</td> -->
          <td width="35%" class="text-right">{{ (postgres.pop2020).toLocaleString() }}</td>
        </tr>

        <tr v-if="postgres.stusps != 'HI'">
          <td v-if="postgres.popdifffromavg > 0">District <span class="font-weight-bold text-needtoshrink-color">above average</span> by...</td>
           <td v-if="postgres.popdifffromavg > 0" class="text-right font-weight-bold text-needtoshrink-color">{{ Math.abs(Math.round(postgres.popdifffromavg)).toLocaleString() }} people</td>
          <td v-if="postgres.popdifffromavg < 0">District <span class="font-weight-bold text-needtoexpand-color">below average</span> by...</td>
          <td v-if="postgres.popdifffromavg < 0" class="text-right font-weight-bold text-needtoexpand-color">{{ Math.abs(Math.round(postgres.popdifffromavg)).toLocaleString() }} people</td>
        </tr>
        <tr v-if="postgres.stusps != 'HI'">
          <td>% difference from avg.</td>
          <td v-if="postgres.deviation > 0.001" class="text-right font-weight-bold text-needtoshrink-color">{{ (postgres.deviation * 100).toFixed(1) }}%</td>
          <td v-if="postgres.deviation < -0.001" class="text-right font-weight-bold text-needtoexpand-color">{{ (postgres.deviation * 100).toFixed(1) }}%</td>
          <td v-if="postgres.deviation >= -0.001 && postgres.deviation <= 0.001" class="text-right font-weight-regular">0%</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

<p class="text-caption">NOTE: 
  <!-- <span v-if="postgres.statefips === '37'"><strong>Current district population</strong> = 2015-2019 American Community Survey block group population estimates allocated to 2019 districts.</span>
  <span v-else><strong>Current district population</strong> = 2015-19 American Community Survey estimate.</span>
  <strong>Average district population</strong> = {{ postgres.statename }}'s 2019 ACS population estimate ({{ postgres.statepop2019.toLocaleString() }} people) divided by # of state legislative upper house seats. <strong>Actual district deviation will be updated</strong> when 2020 Census district population is published. -->
  <strong>Average district population</strong> = {{ postgres.statename }}'s 2020 population ({{ postgres.statepop2020.toLocaleString() }} people) divided by # of state legislative upper house seats.
</p>

  </div>
</template>
<script>
import { Enums, Config } from "../../../../data/Config/Config";
export default {
  name: "TablesStUpper",
  components: {},
  data: function () {
    return {
      Config: Config
    };
  },
  mounted: function () {},
  methods: {},
  watch: {},
  computed: {
    postgres: function () {
     
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
  },
};
</script>
<style></style>